import { useState, useEffect } from 'react';
import { configs } from '@constants/configs/configs';


export const useHotKeys = ( { code1, code2, code3, type1, type2, type3 } ) => {

    const path = window.location.origin;

    const [ isHotKeyResultPanelShown, switchHotKeyResultPanel ] = useState(false);
    const [ isHotKeyResultPanelAvailable, switchHotKeyResultPanelAvailability ] = useState(false);


    const shortcutKey = `${code1}_${code2}_${code3}`;

    const codes = [
        {
            code: code1,
            type: type1
        },
        {
            code: code2,
            type: type2
        },
        {
            code: code3,
            type: type3
        }
    ];

    const [ keys, setKeys ] = useState(Object.assign(
        {},
        ...codes.map(code => ({
            [code.type]: false
        }))
    ));


    const eligiblePaths = [
        'eng.vimo.com',
        'ghixqa.com',
        'localhost:8888',
        'localhost:7777',
        'localhost:8080'
    ];

    useEffect(() => {

        if(configs.ENV.DEVELOPMENT || (path && eligiblePaths.some(p => path.includes(p))) ) {

            !isHotKeyResultPanelAvailable && switchHotKeyResultPanelAvailability(!isHotKeyResultPanelAvailable);

        }
    }, [ ] );

    useEffect(() => {
        window.shortcutListeners = window.shortcutListeners || {};
        if (window.shortcutListeners[shortcutKey]) {
            document.removeEventListener('keydown', window.shortcutListeners[shortcutKey].onKeyDown, false);// = keyDownEvent;
            document.removeEventListener('keyup', window.shortcutListeners[shortcutKey].onKeyUp, false);// =
        }
        const onKeyDown = () => keyDownEvent();
        const onKeyUp = () => keyUpEvent();

        document.addEventListener('keydown', onKeyDown, false);// = keyDownEvent;
        document.addEventListener('keyup', onKeyUp, false);// = keyDownEvent;*/
        window.shortcutListeners[shortcutKey] = {
            onKeyDown, onKeyUp
        };


        const updateKeys = (type, value) => {
            setKeys(keys => ({
                ...keys,
                [type]: value
            }));
        };

        function keyDownEvent() {
            const isNeededCode = codes.find(code => code.code === event.keyCode);
            if (isNeededCode) {
                updateKeys(isNeededCode.type, true);
            }
        }

        function keyUpEvent() {
            const isNeededCode = codes.find(code => code.code === event.keyCode);
            if (isNeededCode) {
                updateKeys(isNeededCode.type, false);
            }

            if (Object.values(keys).every(key => key)) {
                switchHotKeyResultPanel(!isHotKeyResultPanelShown);
            }

        }


    });

    return isHotKeyResultPanelAvailable && isHotKeyResultPanelShown;
};
